"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMerged = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var noop = function () { return undefined; };
function useMerged(init, value1, value2, value3, value4, value5, value6, value7, value8, value9) {
    var _a = tslib_1.__read((0, react_1.useState)(init), 2), merged = _a[0], set = _a[1];
    (0, react_1.useEffect)(function () { return (value1 !== undefined ? set(value1) : noop()); }, [value1]);
    (0, react_1.useEffect)(function () { return (value2 !== undefined ? set(value2) : noop()); }, [value2]);
    (0, react_1.useEffect)(function () { return (value3 !== undefined ? set(value3) : noop()); }, [value3]);
    (0, react_1.useEffect)(function () { return (value4 !== undefined ? set(value4) : noop()); }, [value4]);
    (0, react_1.useEffect)(function () { return (value5 !== undefined ? set(value5) : noop()); }, [value5]);
    (0, react_1.useEffect)(function () { return (value6 !== undefined ? set(value6) : noop()); }, [value6]);
    (0, react_1.useEffect)(function () { return (value7 !== undefined ? set(value7) : noop()); }, [value7]);
    (0, react_1.useEffect)(function () { return (value8 !== undefined ? set(value8) : noop()); }, [value8]);
    (0, react_1.useEffect)(function () { return (value9 !== undefined ? set(value9) : noop()); }, [value9]);
    return merged;
}
exports.useMerged = useMerged;
